import { useState } from "react";
import { axiosPrivate } from "../../api/axios";
import { useTranslation } from "react-i18next";

import '../../css/TermsModal.css'

export default function TermsModal({ onAccepted }) {
    const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleAccept = async () => {
    try {
      setLoading(true);
      const res = await axiosPrivate.post("/legal/accept");
      onAccepted(res.data.acceptedAt);
    } catch (err) {
      console.error("Acceptance error", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="terms-modal-overlay">
      <div className="terms-modal">
        <h2>{t("legalModal.title")}</h2>
        <p>{t("legalModal.subtitle")}</p>

        <div className="actions">
          <a href="/legal/terms" target="_blank" rel="noopener noreferrer">
            {t("legal.terms")}
          </a>
          <a href="/legal/privacy" target="_blank" rel="noopener noreferrer">
            {t("legal.privacy")}
          </a>
        </div>

        <button className="button-white" onClick={handleAccept} disabled={loading}>
          {loading ? t("legalModal.saving") : t("legalModal.accept")}
        </button>
      </div>
    </div>
  );
}
